import { createStructuredSelector } from 'reselect';
import { selectCsrBusinessFunction } from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectSelectedCharityName,
  selectEditMode,
  selectGrantAmount,
  selectStartDate,
  selectNoOfPayments,
  selectScheduleType,
  selectAllocationType,
} from './RecommendGrantPageSelectors';
import {
  selectFrequency,
  selectAllocations,
  selectAllSharesAllPools,
  selectAllShares,
} from './ConfirmationPageSelectors';
import { selectGrantId, selectPendingSpawnId } from './EditGrantSelectors';

export const selectPoolsAllocation = (state) => {
  const { poolsAllocation } = fetchRAGState(state);
  return poolsAllocation;
};

export const selectInvestmentAllocationDataLoading = (state) => {
  const { investmentAllocationData } = fetchRAGState(state);
  return investmentAllocationData.isLoading;
};

export const selectStatus = (state) => {
  const { status } = fetchRAGState(state);
  return status;
};

export const selectReGrant = (state) => {
  const { regrant } = fetchRAGState(state);
  return regrant;
};

const selectContribAndFeeLoading = (state) => {
  const { contribAndFeeLoading } = fetchRAGState(state);
  return contribAndFeeLoading;
};

const selectAdminFee = (state) => {
  const { adminFee } = fetchRAGState(state);
  return adminFee;
};

const selectPoolsPendingContrib = (state) => {
  const { poolsPendingContrib } = fetchRAGState(state);
  return poolsPendingContrib;
};

const selectGrantTemplateId = (state) => {
  const { grantTemplateId } = fetchRAGState(state);
  return grantTemplateId;
};

export const scheduleAllocationDerivedStates = createStructuredSelector({
  allocationData: selectPoolsAllocation,
  allocationLoading: selectInvestmentAllocationDataLoading,
  grantName: selectSelectedCharityName,
  editMode: selectEditMode,
  selectedAmount: selectGrantAmount,
  selectedDate: selectStartDate,
  selectedFrequency: selectFrequency,
  selectedNoOfPayments: selectNoOfPayments,
  selectedSchedule: selectScheduleType,
  selectedAllocType: selectAllocationType,
  selectedAllocations: selectAllocations,
  selectedAllSharesAllPools: selectAllSharesAllPools,
  selectedAllShares: selectAllShares,
  status: selectStatus,
  isRegrantFlow: selectReGrant,
  contribAndFeeLoading: selectContribAndFeeLoading,
  adminFee: selectAdminFee,
  poolsPendingContrib: selectPoolsPendingContrib,
  grantId: selectGrantId,
  csrBusinessFunction: selectCsrBusinessFunction,
  grantTemplateId: selectGrantTemplateId,
  pendingSpawnId: selectPendingSpawnId,
});
